<template>
  <Modal :id="id" class="agreement" ok-title="关闭" hide_cancel="true" :ok-disabled="!content" @ok="agree" size="lg" scrollable=true>
    <div v-if="content" id="content" v-html="content" class="scrolling content">
    </div>
    <Placeholder v-else />
  </Modal>
</template>

<script>
import axios from 'axios';
import Modal from './modal.vue';
import Placeholder from './placeholder';

export default {
  name: 'AgreementModal',
  props: ['id', 'kind'],
  components: {
    Modal,
    Placeholder,
  },
  data: function () {
    return {
      content: '',
    };
  },
  methods: {
    agree() {
      this.$emit('ok')
    },
  },
  async mounted() {
    var url;
    switch(this.kind) {
      case 'user':
        url = 'https://docs.hondcloud.com/wp-json/wp/v2/pages/25';
        break;
      case 'service':
        url = 'https://docs.hondcloud.com/wp-json/wp/v2/pages/43';
        break;
      case 'privacy':
        url = 'https://docs.hondcloud.com/wp-json/wp/v2/pages/46';
        break;
      default:
        this.content = '错误：未知文档类型';
    }
    var r = await axios.get(url);
    this.content = r.data.content.rendered;
  },
}
</script>
<style>
.agreement h2 {
  text-align: center;
  font-size: 1.5rem;
}
.agreement h4 {
  margin-top: 1rem;
  font-size: 1.3rem;
  font-weight: bold;
}
.agreement p {
  text-indent: 2rem;
  margin-top: 1rem;
}
.agreement ul {
  list-style: disc;
  margin-left: 4rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.agreement ol {
  list-style: decimal;
  margin-left: 2rem;
}
</style>
